import { useEffect } from "react";

interface Branding {
  logoUrl: string | null;
  faviconUrl: string | null;
  brandColor: string | null;
  splashBackground: string | null;
  appName: string;
  hidePoweredBy: boolean;
}

const DEFAULT_TITLE = "Wondermaps";
const DEFAULT_FAVICON = "/wondermaps-logomark.svg";

/**
 * Applies branding to document: title, favicon, CSS vars
 */
export function useBranding(branding: Branding | null, mapName?: string): void {
  useEffect(() => {
    if (!branding) return;

    // Store original values
    const originalTitle = document.title;
    const existingFavicon = document.querySelector<HTMLLinkElement>(
      'link[rel="icon"]'
    );
    const originalFaviconHref = existingFavicon?.href;

    // Set title
    document.title = mapName
      ? `${mapName} | ${branding.appName}`
      : branding.appName;

    // Set favicon
    if (branding.faviconUrl) {
      let faviconLink = document.querySelector<HTMLLinkElement>(
        'link[rel="icon"]'
      );
      if (!faviconLink) {
        faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        document.head.appendChild(faviconLink);
      }
      faviconLink.href = branding.faviconUrl;
    }

    // Set CSS var
    if (branding.brandColor) {
      document.documentElement.style.setProperty(
        "--brand-color",
        branding.brandColor
      );
    }

    // Cleanup
    return () => {
      document.title = originalTitle || DEFAULT_TITLE;

      const faviconLink = document.querySelector<HTMLLinkElement>(
        'link[rel="icon"]'
      );
      if (faviconLink) {
        faviconLink.href = originalFaviconHref || DEFAULT_FAVICON;
      }

      document.documentElement.style.removeProperty("--brand-color");
    };
  }, [branding, mapName]);
}
